<template>
    <div class="columns is-multiline">
        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="column is-full">
            <b-field label="Visible">
                <b-switch
                v-model="page.visible">
                </b-switch>
            </b-field>
        </div>
        <div class="column is-full">
            <b-field label="Mostra en menu y navegacion">
                <b-switch
                v-model="page.inNav">
                </b-switch>
            </b-field>
        </div>
        <div class="column is-full">
            <b-field label="Titulo">
                <b-input
                v-model="page.title">
                </b-input>
            </b-field>
        </div>
        <div class="column is-full">
            <b-field label="Contenido">
                <quillEditor
                class="editor__content"
                ref="myTextEditor"
                :value="page.content"
                :options="editorOption"
                @change="onEditorChange"/>
            </b-field>
        </div>

        <div class="column is-full has-text-centered">
            <b-button 
            type="is-primary"
            rounded
            @click="updateOrCreatePage"
            >
            Guardar
            <b-icon icon="save" size="is-small"></b-icon>
            </b-button>
        </div>

    </div>    
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import { getHandler, patchHandler, postHandler, debounce } from '../../../services/http';

var Font = Quill.import('formats/font');
Font.whitelist = ['montserrat', 'roboto'];
Quill.register(Font, true);
var Size = Quill.import('attributors/style/size');
Size.whitelist = ['10px', '14px', '16px', '18px', '20px'];
Quill.register(Size, true);

export default {
    components:{
        quillEditor
    },
    props:{
        createPageUrl:{
            type:String,
            default:""
        },
        isEdit:{
            type:String,
            default:""
        },
        editUrl:{
            type:String,
            default:""
        },
        listUrl:{
            type: String,
            default:""
        }
    },
    data(){
        return{
            editorOption: {
                modules: {
                    toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'direction': 'rtl' }],
                    [{ 'size': ['10px', '14px', '16px', '18px', '20px'] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'font': ['roboto', 'montserrat'] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'align': [] }],
                    ['clean'],
                    ['link', 'video']
                    ],
                }
            },
            page:{}
        }
    },
    methods:{
        async fetchPage(){
            if( this.isEdit == 'True'){
                this.loading = true
                this.page = await getHandler(this.editUrl, {error:false, success:false})
                this.loading = false
            } else{
                this.page = {}
            }
        },
        async updateOrCreatePage(){
            var error = {resource:"notify"}
            var success = {resource:"notify"}
            this.loading = true
            if (this.isEdit == 'True'){
                var response = patchHandler(this.editUrl, this.page, {error, success})
            } else{
                var response = postHandler(this.createPageUrl, this.page, {error, success})
                window.location.href = this.listUrl
            }
            this.loading = false
        },
        onEditorChange: debounce(function(value) {
            this.page.content = value.html
        }, 266),
    },
    created(){
        this.fetchPage()
    }
}
</script>